import React, {useContext,createContext,useState} from 'react';

import api from  '../webApi';
import isEmpty from 'lodash/isEmpty';
// #region Organization 

export  const SendEmployeeForm =async(formData)=>{
    let newOrg = {};
          await api.post('api/mail',formData
            //    ,{headers:{'Content-Type':'multipart/form-data'} }
            ,{headers:{"Access-Control-Allow-Headers":"Content-Type"
                ,    "Access-Control-Allow-Methods":"*"
                ,"Access-Control-Allow-Origin":"*"
                ,"Content-type":"application/json; charset=utf-8"
        }
    }
            )
                .then(res=>{
                  newOrg=res.data;
                })
                .catch((error)=>
            {
                console.log('error:',error);
                throw new Error('SendEmployeeForm Failed');
              });    
    return newOrg;
  };
